import { classMap } from "lit/directives/class-map.js";
import { when } from "lit/directives/when.js";
import { InternalElement } from "../lib/internal-element.js";
import { css, html } from "lit";
import { property, customElement } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let PerilList = class extends InternalElement {
  render() {
    var _a, _b;
    return html`
      <section id="perils">
        ${when((_a = this.quote) == null ? void 0 : _a.product.peril_heading, () => {
      var _a2;
      return html`<h4>${(_a2 = this.quote) == null ? void 0 : _a2.product.peril_heading}</h4>`;
    })}
        ${when((_b = this.quote) == null ? void 0 : _b.product.perils, () => {
      var _a2;
      return html`
          <ul class=${classMap({ declined: this.declined })}>
            ${(_a2 = this.quote) == null ? void 0 : _a2.product.perils.map((peril) => html`
              <li>
                ${peril}
              </li>
            `)}
          </ul>
        `;
    })}
      </section>
    `;
  }
};
PerilList.styles = css`
    /* PERIL STYLES */ 

    #perils {
      margin-bottom: 10px;
    }

    #perils h4 {
      margin: 0 0 8px 0;
    }

    #perils ul {
      display: flex;
      flex-wrap: wrap;
      margin: 0;
      column-width: min-content;
      list-style: none;
      list-style-position: outside;
      padding-inline-start: 0;
    }
  
    #perils li {
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      flex: 1 1 49%;
      align-items: flex-start;
      padding: 3px 3px 3px 0;
      font-family: var(--default-vi-font-family);
    }
  
    #perils li.force-column {
      flex: 1 1 100%;
    }
  
    #perils li:before {
      display: inline-block;
      min-width: 20px;
      height: 20px;
      line-height: 1.6rem;
      margin-right: 10px;
      content: '';
      mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNiwxMmMzLjMxLDAsNi0yLjY5LDYtNlM5LjMxLDAsNiwwLDAsMi42OSwwLDZzMi42OSw2LDYsNlptMi41NC03LjE1Yy4yNi0uMjkuMjMtLjczLS4wNi0uOTktLjI5LS4yNi0uNzMtLjIzLS45OS4wNmwtMi40LDIuNy0uNjQtLjU5Yy0uMjgtLjI2LS43My0uMjQtLjk5LjA0LS4yNi4yOC0uMjQuNzMuMDQuOTlsMS4wMS45NGMuMzcuMzQuOTUuMzEsMS4yOC0uMDZsMi43NC0zLjA4WiIvPgo8L3N2Zz4=");
      -webkit-mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtNiwxMmMzLjMxLDAsNi0yLjY5LDYtNlM5LjMxLDAsNiwwLDAsMi42OSwwLDZzMi42OSw2LDYsNlptMi41NC03LjE1Yy4yNi0uMjkuMjMtLjczLS4wNi0uOTktLjI5LS4yNi0uNzMtLjIzLS45OS4wNmwtMi40LDIuNy0uNjQtLjU5Yy0uMjgtLjI2LS43My0uMjQtLjk5LjA0LS4yNi4yOC0uMjQuNzMuMDQuOTlsMS4wMS45NGMuMzcuMzQuOTUuMzEsMS4yOC0uMDZsMi43NC0zLjA4WiIvPgo8L3N2Zz4=");
      background: var(--default-vi-descriptors-checkmark-accept-color);
    }
  
    #perils .declined li:before {
      mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtMTIsNmMwLDMuMzEtMi42OSw2LTYsNlMwLDkuMzEsMCw2LDIuNjksMCw2LDBzNiwyLjY5LDYsNlptLTMuNzQtMi4yNmMuMjcuMjcuMjcuNzIsMCwuOTlsLTEuMjcsMS4yNywxLjI3LDEuMjdjLjI3LjI3LjI3LjcyLDAsLjk5LS4yNy4yNy0uNzIuMjctLjk5LDBsLTEuMjctMS4yNy0xLjI3LDEuMjdjLS4yNy4yNy0uNzIuMjctLjk5LDAtLjI3LS4yNy0uMjctLjcyLDAtLjk5bDEuMjctMS4yNy0xLjI3LTEuMjdjLS4yNy0uMjctLjI3LS43MiwwLS45OS4yNy0uMjcuNzItLjI3Ljk5LDBsMS4yNywxLjI3LDEuMjctMS4yN2MuMjctLjI3LjcyLS4yNy45OSwwWiIvPgo8L3N2Zz4=");
      -webkit-mask: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMiAxMiI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogY3VycmVudENvbG9yOwogICAgICAgIGZpbGwtcnVsZTogZXZlbm9kZDsKICAgICAgICBzdHJva2Utd2lkdGg6IDBweDsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHBhdGggY2xhc3M9ImNscy0xIiBkPSJtMTIsNmMwLDMuMzEtMi42OSw2LTYsNlMwLDkuMzEsMCw2LDIuNjksMCw2LDBzNiwyLjY5LDYsNlptLTMuNzQtMi4yNmMuMjcuMjcuMjcuNzIsMCwuOTlsLTEuMjcsMS4yNywxLjI3LDEuMjdjLjI3LjI3LjI3LjcyLDAsLjk5LS4yNy4yNy0uNzIuMjctLjk5LDBsLTEuMjctMS4yNy0xLjI3LDEuMjdjLS4yNy4yNy0uNzIuMjctLjk5LDAtLjI3LS4yNy0uMjctLjcyLDAtLjk5bDEuMjctMS4yNy0xLjI3LTEuMjdjLS4yNy0uMjctLjI3LS43MiwwLS45OS4yNy0uMjcuNzItLjI3Ljk5LDBsMS4yNywxLjI3LDEuMjctMS4yN2MuMjctLjI3LjcyLS4yNy45OSwwWiIvPgo8L3N2Zz4=");
      background: var(--default-vi-descriptors-checkmark-decline-color);
    }
    
    @container (max-width: 600px) {
      #perils li {
        flex: 1 1 100%;
        white-space: wrap
      }
    }
    @media only screen and (max-width: 600px) {
      #perils li {
        flex: 1 1 100%;
        white-space: wrap
      }
    }
  `;
__decorateClass([
  property({ type: Boolean })
], PerilList.prototype, "declined", 2);
PerilList = __decorateClass([
  customElement("peril-list")
], PerilList);
export {
  PerilList
};
